import React from 'react';
import { Navigate } from 'react-router-dom';
import { EnhancedRouteProps } from 'router/routes/Enhanced/Enhanced.route';
import ShareableLinkDocuments from './pages/ShareableLinkDocuments';

const SL_DOCUMENTS_ROUTE = 'documents';

export default [
  {
    path: `${SL_DOCUMENTS_ROUTE}/:documentId`,
    element: ShareableLinkDocuments,
  },
  {
    path: SL_DOCUMENTS_ROUTE,
    element: ShareableLinkDocuments,
  },
  {
    index: true,
    element: <Navigate to={SL_DOCUMENTS_ROUTE} replace />,
  },
] as Array<EnhancedRouteProps>;
